<template>
<span>
  <btn size="xs" :type="exportOpen ? 'primary' : 'success'" @click="exportCSV"
        :disabled="!enabled">
    <span class="glyphicon glyphicon-download-alt"
          aria-hidden="true">
    </span>
    Export CSV
  </btn>
  <save-blob :target="csv.target"></save-blob>
</span>
</template>
<script>
import { mapState } from 'vuex'
import modules from '@/sui/data/modules'
import stringify from 'csv-stringify'
import moment from 'moment'
import saveblob from '@/sui/components/saveblob'

export default {
  name: 'validate-sheets',
  props: {
    surveillance: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    exportOpen: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      csv: {
        target: null
      },
      show: false,
      enabled: true
    }
  },

  computed: {
    ...mapState({
      full: state => state.sheet.full,
      denominators: state => state.denominators.edit
    })
  },

  methods: {
    exportCSV: function () {
      const vm = this
      vm.$store.dispatch(
        'sheet/full',
        {
          t: vm.type,
          sv: vm.surveillance.id,
          y: vm.surveillance.year,
          st: this.exportOpen ? 'open' : 'valid'
        }
      ).then(
        (response) => {
          const { err, v } = response.data
          if (err == null && v != null) {
            if (vm.denominators != null &&
                vm.denominators.sv === vm.surveillance.id) {
              this.convertToCSV(v)
            } else {
              const values = v
              const request = { s: vm.surveillance.id, y: vm.surveillance.year }
              this.$store.dispatch('denominators/edit', request).then(
                (r) => {
                  const { err, v } = r.data
                  if (err == null || err === '[NotFound]') {
                    if (v == null || v.sv !== request.s) {
                      vm.$store.commit('denominators/empty', request.y)
                    }
                    this.convertToCSV(values)
                  } else {
                    vm.$notify(
                      {
                        type: 'danger',
                        title: `Erreur interne !`,
                        duration: 10000,
                        content: err
                      }
                    )
                  }
                }
              ).catch(
                e => {
                  vm.$notify({
                    type: 'danger',
                    title: `Erreur interne !`,
                    duration: 10000,
                    content: `${e}`
                  })
                }
              )
            }
          } else if (err != null) {
            vm.$notify({
              type: 'danger',
              title: `Erreur interne !`,
              duration: 10000,
              content: err
            })
          }
          return response
        }
      ).catch(
        e => {
          vm.$notify({
            type: 'danger',
            title: `Erreur interne !`,
            duration: 10000,
            content: `${e}`
          })
        }
      )
    },

    convertToCSV: function (v) {
      const vm = this
      const year = vm.surveillance.year
      const module = modules[year][vm.type]
      const values = module.sheets.flatten(
        {
          type: vm.type,
          treeFields: module.sheets.edit.fields,
          sheets: v,
          onlyClosed: false,
          surveillances: [ vm.surveillance ],
          denominators: [ vm.denominators ],
          removeEmptyColumns: module.removeEmptyColumns
        }
      )
      const finess = vm.surveillance.establishment.finess
      const date = moment().format('DD-MM-YYYY-hh-mm-ss')
      const filename =
        `SPIADI${year} - ${finess} - ${module.label} - ${date}.csv`
      stringify(
        values.sheets, values.options,
        (err, output) => {
          if (err == null) {
            setTimeout(
              function () {
                vm.csv.target = {
                  filename: filename,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        }
      )
    }
  },

  components: {
    'save-blob': saveblob
  }
}
</script>
<style lang="less" scoped>
</style>
